import { generateCookie } from 'utils';

export const isCookieValid = (cookie: { release: string }): boolean => {
  return cookie.release === generateCookie();
};
